export const OAUTH_CLIENTS = {
  "adn-voting": {
    id: "adn-voting",
    name: "Người Giữ Lửa - ADN Edutalk",
    iconEmoji: "🔥",
    logoVariant: "adn",
    description:
      "Hệ thống định danh Edutalk sẽ chia sẻ, xử lý dữ liệu sau với ứng dụng bình chọn ADN.",
    purpose:
      "Các thông tin nêu trên được chia sẻ nhằm mục đích thực hiện đăng nhập và xác thực quyền bình chọn trên hệ thống Người Giữ Lửa - ADN Edutalk 2026.",
    expiredMessage:
      "Phiên xác nhận đã hết hạn. Vui lòng thử đăng nhập lại từ ADN.",
  },
  "ello-kanban": {
    id: "ello-kanban",
    name: "Ello Kanban - Edutalk",
    iconEmoji: "📋",
    logoVariant: "ello",
    description:
      "Hệ thống định danh Edutalk sẽ chia sẻ, xử lý dữ liệu sau với ứng dụng quản lý công việc Ello.",
    purpose:
      "Các thông tin nêu trên được chia sẻ nhằm mục đích thực hiện đăng nhập và xác thực tài khoản trên hệ thống Ello Kanban - Edutalk.",
    expiredMessage:
      "Phiên xác nhận đã hết hạn. Vui lòng thử đăng nhập lại từ Ello.",
  },
};

export const DEFAULT_OAUTH_CLIENT_ID = "adn-voting";

export function resolveOAuthClient(clientId) {
  return OAUTH_CLIENTS[clientId] || null;
}
